import React, { ReactElement } from 'react';
import Buttons, { ButtonProps } from 'components/Buttons/Buttons';
import { useToast } from '@hooks';
import { ToastTypeVariants } from '@/context/ToastContext';
import classNames from 'classnames';
import s from './CopyButton.module.scss';

type Props = ButtonProps & {
  text: string;
  children: React.ReactNode;
};

function CopyButton({ text, children = 'Copy', ...restProps }: Props): ReactElement {
  const addToast = useToast();

  const copy = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(text);
      addToast(ToastTypeVariants.SUCCESS, 'Copied to clipboard!');
    } catch (e) {
      addToast(ToastTypeVariants.ERROR, 'Error copying to clipboard!');
    }
  };

  return (
    <Buttons className={classNames(!restProps.isPrimary && !restProps.isSecondary && s.copy)} {...restProps} onClick={copy}>
      {children}
    </Buttons>
  );
}

export default CopyButton;
